"use strict";
/********************************************************************************
  HxObjectStore.ts
 
  Copyright (c) Microsoft Corporation. All rights reserved.
 ********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxObjectStore = void 0;
var HxObjectStore = /** @class */ (function () {
    function HxObjectStore(nativeInterop) {
        this.objects = new Map();
        this.nativeInterop = nativeInterop;
    }
    // Get an object from the active set using compactId
    HxObjectStore.prototype.findObjectByCompactId = function (compactId) {
        var entry = this.objects.get(compactId);
        return entry ? entry.object : null;
    };
    // Get an object from the active set
    HxObjectStore.prototype.findObject = function (objectId) {
        return this.findObjectByCompactId(objectId.getCompactIDString());
    };
    // Return value indicates whether anything changed
    HxObjectStore.prototype.updateObject = function (object) {
        var entry = this.objects.get(object.objectId.getCompactIDString());
        if (entry) {
            if (entry.object && object.storageSequenceNumber < entry.object.storageSequenceNumber) {
                // log(`onObjectDeleted (${object.objectId}, ${object.objectType)) rejected due to insufficient storage sequence number: ${object.storageSequenceNumber} < ${entry.object.storageSequenceNumber}`);
                return false;
            }
            entry.object = object;
            return true;
        }
        else {
            // If the entry is missing, the client might have released the object in a race with load/notification.
            // Make sure hxcore knows this object is not part js active set.
            this.nativeInterop.deactivateObject(object.objectId, object.storageSequenceNumber);
            return false;
        }
    };
    HxObjectStore.prototype.onObjectDeleted = function (objectId, storageSequenceNumber) {
        var entry = this.objects.get(objectId.getCompactIDString());
        // If the entry is missing, the client might have released the object in a race with load/notification
        if (entry) {
            if (entry.object && storageSequenceNumber < entry.object.storageSequenceNumber) {
                // log(`onObjectDeleted (${entry.object.objectId}, ${entry.object.objectType)) rejected due to insufficient storage sequence number: ${storageSequenceNumber} < ${entry.object.storageSequenceNumber}`);
                return [];
            }
            var sessionIds = Array.from(entry.sessionRefs.keys());
            this.objects.delete(objectId.getCompactIDString());
            return sessionIds;
        }
        return [];
    };
    HxObjectStore.prototype.addRefObject = function (objectCompactId, sessionId) {
        var entry = this.objects.get(objectCompactId);
        if (entry) {
            entry.refCount++;
            var currentRefCount = entry.sessionRefs.get(sessionId);
            if (currentRefCount !== undefined) {
                entry.sessionRefs.set(sessionId, currentRefCount + 1);
            }
            else {
                entry.sessionRefs.set(sessionId, 1);
            }
        }
        else {
            this.objects.set(objectCompactId, { object: undefined, refCount: 1, sessionRefs: new Map([[sessionId, 1]]) });
        }
    };
    HxObjectStore.prototype.releaseObject = function (objectCompactId, sessionId) {
        var entry = this.objects.get(objectCompactId);
        // When an object in a collection is deleted we see an object deleted notification
        // and then a collection change. When we process the collection change we may
        // have already removed the object.
        if (entry) {
            entry.refCount--;
            var currentRefCount = entry.sessionRefs.get(sessionId);
            if (currentRefCount > 1) {
                entry.sessionRefs.set(sessionId, currentRefCount - 1);
            }
            else {
                entry.sessionRefs.delete(sessionId);
            }
            if (entry.refCount === 0) {
                if (entry.object) {
                    this.nativeInterop.deactivateObject(entry.object.objectId, entry.object.storageSequenceNumber);
                }
                this.objects.delete(objectCompactId);
            }
        }
    };
    HxObjectStore.prototype.getSessionsForObject = function (objectCompactId) {
        var entry = this.objects.get(objectCompactId);
        if (entry) {
            return Array.from(entry.sessionRefs.keys());
        }
        else {
            return [];
        }
    };
    return HxObjectStore;
}());
exports.HxObjectStore = HxObjectStore;
exports.default = HxObjectStore;
